import Vue from 'vue'
import VueViewports from 'vue-viewports'
import store from '../store'
import {
  SET_VIEWPORT
} from '../store/mutation-types'

Vue.use(VueViewports, [
  {
    rule: '1000px',
    label: 'desktop'
  }
])

const defaultViewport = { rule: '0px', label: 'mobile' }

store.commit(SET_VIEWPORT, VueViewports.currentViewport || defaultViewport)

window.addEventListener('resize', () => {
  store.commit(SET_VIEWPORT, VueViewports.currentViewport || defaultViewport)
})
